import { setToStringTag } from "./symbols";

export function patchClass<Key extends keyof typeof globalThis>(
  hmr: ImportMeta["hot"],
  name: Key,
  patcher: (original: (typeof globalThis)[Key]) => (typeof globalThis)[Key]
) {
  let OriginalClass: (typeof globalThis)[Key];
  // combine
  //  - import.meta.hot for three shaking
  //  - passed in hmr locale-to-module for memoization
  if (!import.meta.hot || !hmr?.data) {
    OriginalClass = globalThis[name];
  } else {
    const key = `original$${name}`;
    if (hmr?.data[key]) {
      OriginalClass = hmr.data[key];
    } else {
      OriginalClass = globalThis[name];
      hmr.data[key] = OriginalClass;
    }
  }

  const PatchedClass = patcher(OriginalClass);
  setToStringTag(PatchedClass, name);
  globalThis[name] = PatchedClass;
}
